import { createAsyncThunk } from '@reduxjs/toolkit';
import { getChecklistUserApprovalFiles } from '../../api/checklist-user-approval-files';

export const getChecklistUserApprovalFilesAsync = createAsyncThunk(
  'getChecklistUserApprovalFiles/getChecklistUserApprovalFiles',
  getChecklistUserApprovalFiles
);
